import { render } from "./File.vue?vue&type=template&id=336316ec&ts=true"
import script from "./File.vue?vue&type=script&lang=ts"
export * from "./File.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__